import React from "react";
import { useNavigate } from "react-router-dom";
import { Search, LogOut, User } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { ROLE_LABELS } from "../../lib/rbac";
import NotificationBell from "../NotificationBell";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Input } from "../ui/input";

export default function Topbar({ title, subtitle, actions }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    return (
        <header
            data-testid="app-topbar"
            className="h-16 flex items-center gap-4 px-6 border-b bg-card sticky top-0 z-30"
        >
            <div className="flex-1 min-w-0">
                <div className="text-[11px] uppercase tracking-widest text-muted-foreground">
                    {subtitle || "Satın Alma"}
                </div>
                <h1 className="text-lg font-semibold text-foreground truncate">{title}</h1>
            </div>
            <div className="hidden md:flex items-center relative w-72">
                <Search className="w-4 h-4 absolute left-3 text-muted-foreground" />
                <Input
                    data-testid="global-search"
                    placeholder="Ara: sipariş, tedarikçi, ürün..."
                    className="pl-9 h-9 bg-muted/40 border-border"
                />
            </div>
            {actions}
            <NotificationBell />
            <DropdownMenu>
                <DropdownMenuTrigger data-testid="user-menu-trigger" asChild>
                    <button className="flex items-center gap-2 px-2 py-1.5 rounded-md hover:bg-muted transition-colors">
                        <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-medium">
                            {user?.name?.[0]?.toUpperCase() || "?"}
                        </div>
                        <div className="text-left hidden md:block">
                            <div className="text-sm font-medium leading-tight">{user?.name}</div>
                            <div className="text-[11px] text-muted-foreground leading-tight">{ROLE_LABELS[user?.role] || user?.role}</div>
                        </div>
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-52">
                    <DropdownMenuLabel>{user?.email}</DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem
                        data-testid="menu-profile"
                        onClick={() => navigate("/profile")}
                    >
                        <User className="w-4 h-4 mr-2" /> Profil
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem
                        data-testid="logout-btn"
                        onClick={logout}
                        className="text-destructive focus:text-destructive"
                    >
                        <LogOut className="w-4 h-4 mr-2" /> Çıkış Yap
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </header>
    );
}
